import React, {useState} from "react";
import {modalCRUDService} from "../services/modalCRUDService";
import {Colors} from "../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";


const HeaderComponent = ({id, label, expanded, handleChange}) => {

  const [stateArrow, setStateArrow] = useState(expanded);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0 w-100 font-weight-bold">{label}</h5>
      <Tooltip title="Mostrar/Ocultar" aria-label="hideandshow">
        <a onClick={() => {setStateArrow(!stateArrow)
          if(handleChange != undefined) handleChange(!stateArrow)}}
           data-toggle="collapse" data-target={`#collapseContainer${id}`} aria-expanded={expanded} aria-controls={`#collapseContainer${id}`} className="icon-container-actions d-flex mr-0">
          <div style={{backgroundColor: Colors.WHITE, boxShadow: "none"}}/>
          <i style={{color: Colors.COLOR_BLUE_THEME}} className={stateArrow ? "fas fa-angle-up fa-2x" : "fas fa-angle-down fa-2x"}/>
        </a>
      </Tooltip>
    </div>
  )

}

const ContainerSectionModal = ({label, component, expanded = true, handleChange}) => {

  let id = Math.floor(Math.random() * 100000);

  return(
    <div className="mt-1 p-2 bg-white mb-3 boxShadowLow" style={{border: '1px solid #C6C6C6', borderRadius: 3}}>

      <HeaderComponent id={id} label={label} expanded={expanded} handleChange={handleChange}/>

      <div className={expanded ? "collapse show" : "collapse"} id={`collapseContainer${id}`}>
        <hr className="my-0 p-0 mt-2 mb-3"/>
        {
          component &&
          component
        }
      </div>

    </div>
  )

}

export default ContainerSectionModal;
